import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import t from 'ember-intl/helpers/t';
import type { Signature as ForcProviderBaseSignature } from 'parog-web/components/forc/provider/base';

interface Signature {
  Args: {
    form: ForcProviderBaseSignature['Blocks']['default'][0];
  };
}
export default class MiciBaseConsultFormArticularPain extends Component<Signature> {
  clearChangeset = () => {
    if (!this.args.form.changeset.get('articularPain'))
      this.args.form.changeset.set('articularPainSeverity', undefined);
  };

  <template>
    <@form.FieldsRadioGroup
      @propertyName='articularPain'
      @title={{t 'mici-form.articularPain.long' htmlSafe=true}}
      as |Group|
    >
      <Group.FieldRadio @value={{true}} @label='Oui' />
      <Group.FieldRadio
        @value={{false}}
        @label='Non'
        {{on 'click' this.clearChangeset}}
      />
    </@form.FieldsRadioGroup>
  </template>
}
